import moment from 'moment';

export const schema = {
  type: 'object',
  required: ['dateOfService'],
  properties: {
    licenseNumber: {
      type: 'string',
      title: 'License Number',
    },
    dateOfService: {
      type: 'string',
      title: 'Date of Service',
      format: 'date',
      default: moment().format('YYYY-MM-DD'),
    },
    therapistFirstName: {
      type: 'string',
      title: 'Therapist First Name',
    },
    therapistLastName: {
      type: 'string',
      title: 'Therapist Last Name',
    },
    notes: {
      type: 'string',
      title: 'Additional Comments/Notes',
    },
  },
};
